module.exports = __webpack_public_path__ + "static/media/sl-podjetniski-sklad-s.6ab1921b.webp";